import {useMemo} from "react";
import type {
    ChecklistData,
    CollectionDataResponse,
} from "../../types";
import {computeViewFiltering} from "../utils";

/**
 * Computes the active label selection per view group, filters the TOC
 * by those labels, and determines the effective root node ID.
 *
 * Changes when: collection or dimension selection changes.
 * Pure logic lives in `computeViewFiltering` (utils) — shared with the
 * control run input builder.
 */
export const useViewFiltering = (
    checklistData: ChecklistData,
    collectionData: CollectionDataResponse | undefined,
    defaultCollectionData: CollectionDataResponse | undefined,
) =>
    useMemo(
        () =>
            computeViewFiltering(
                checklistData,
                collectionData,
                defaultCollectionData,
            ),
        [checklistData, collectionData, defaultCollectionData],
    );
